/* Fuerza Pura - animaciones de aparicion ligeras, carrito directo y copiar cupon. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = '.fp-grid__item,.fp-trust__item,.fp-feat__item,.fp-shelf__head,.fp-slogan__inner>*,.fp-trustband__grid>*,.fp-dist__grid>*,.fp-coll__bar,.fp-pager,.fp-cp__list>li';
  var io = null;

  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
  }

  function scan(scope) {
    if (!io) return;
    var vh = window.innerHeight || 800;
    (scope || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.hasAttribute('data-fp-seen')) return;
      el.setAttribute('data-fp-seen', '');
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92) return;
      var idx = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--fp-i', String(idx % 5));
      el.setAttribute('data-fp-reveal', '');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  /* ---------- Carrito directo ---------- */
  window.FPCart = {
    add: async function (variantId, quantity, productId) {
      var drawer = document.querySelector('cart-items-component[data-drawer]');
      var sectionId = drawer ? drawer.getAttribute('data-section-id') : '';
      var body = { items: [{ id: Number(variantId), quantity: quantity || 1 }] };
      if (sectionId) body.sections = sectionId;

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      var data = await res.json();
      if (!res.ok) {
        var e1 = new Error('add_error');
        e1.added = false;
        throw e1;
      }
      try {
        var cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        var cart = await cartRes.json();
        var mod = await import('@theme/events');
        document.dispatchEvent(new mod.CartAddEvent(cart, 'fp', {
          source: 'fp',
          itemCount: cart.item_count,
          productId: String(productId || ''),
          variantId: String(variantId),
          sections: data.sections || {}
        }));
      } catch (e2) {
        e2.added = true;
        throw e2;
      }
      return true;
    }
  };

  function resetButton(btn, label, original) {
    btn.classList.remove('is-loading', 'is-done');
    btn.removeAttribute('data-busy');
    if (label) label.textContent = original;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-fp-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('data-busy')) return;
    btn.setAttribute('data-busy', '1');
    btn.classList.add('is-loading');
    var label = btn.querySelector('.fp-card__cta-text');
    var original = label ? label.textContent : '';
    if (label) label.textContent = 'Agregando...';
    window.FPCart.add(btn.getAttribute('data-variant-id'), 1, btn.getAttribute('data-product-id')).then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-done');
      if (label) label.textContent = 'Agregado';
      setTimeout(function () { resetButton(btn, label, original); }, 1800);
    }).catch(function (err) {
      window.location.href = err && err.added ? '/cart' : (btn.getAttribute('data-product-url') || '/cart');
    });
  });

  /* ---------- Copiar codigo de cupon ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-fp-copy]') : null;
    if (!b) return;
    var code = b.getAttribute('data-fp-copy');
    var t = b.querySelector('span');
    var original = t ? t.textContent : '';
    function done() {
      if (t) t.textContent = 'Copiado';
      setTimeout(function () { if (t) t.textContent = original; }, 1600);
    }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (x) {}
      document.body.removeChild(ta);
      done();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, fallback);
    } else {
      fallback();
    }
  });
})();
